export const passwordResetStages = {
    EMAIL: 'email',
    OTP: 'otp',
    RESET: 'reset',
};
